// extracted by mini-css-extract-plugin
module.exports = {"media":"_93444fe79c--media--Il9J2","single-row":"_93444fe79c--single-row--xYF9u"};